import { ENVELOPE_DURATION_INCREMENT_MINUTES } from "@repo/domain";

export const MINUTES_PER_UNIT = ENVELOPE_DURATION_INCREMENT_MINUTES;
/**
 * Pixels per authored increment. Editor density leaves room for individually
 * actionable procedure rows inside short steps. All three densities retain a
 * fixed time scale, including drag and resize conversion.
 */
export const UNIT_HEIGHT = { comfortable: 48, compact: 28, editor: 96 } as const;
export type TimelineDensity = keyof typeof UNIT_HEIGHT;

/** Shared fixed scale for authored minutes in read-only and editable timelines. */
export function scale(minutes: number, density: TimelineDensity): number {
  return (minutes / MINUTES_PER_UNIT) * UNIT_HEIGHT[density];
}

/** Unsnapped inverse: callers snap the resulting absolute offset or duration. */
export function pixelsToMinutes(pixels: number, density: TimelineDensity): number {
  return (pixels / UNIT_HEIGHT[density]) * MINUTES_PER_UNIT;
}

/** Nearest domain increment; exact midpoints round toward positive infinity. */
export function snapMinutes(minutes: number): number {
  const snapped = Math.round(minutes / ENVELOPE_DURATION_INCREMENT_MINUTES) * ENVELOPE_DURATION_INCREMENT_MINUTES;
  return snapped === 0 ? 0 : snapped;
}
